/* import __COLOCATED_TEMPLATE__ from './body.hbs'; */
/**

 ## Card Body

 The `sq-card/body` block component is designed to be used as a contextual component in: [sq-card](/components/glass/sq-card.html).

 **/

import Component from '@ember/component';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  classNames: ['card__body']
});